import { render } from "./BaseBankDetails.vue?vue&type=template&id=d5501bac"
import script from "./BaseBankDetails.vue?vue&type=script&lang=js"
export * from "./BaseBankDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__